import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {CardComponent} from '../card/card.component';

@Component({
  selector: 'af-welcome',
  imports: [TranslatePipe, CardComponent],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent {

}
